import { MutableRefObject } from 'react'
import moment from 'moment/moment'
import { GridColDef } from '@microservices/wiskey-react-table-component'

import { ObjectXDynamicCell } from '@components/TimeLineGrid/components/ObjectXDynamicCell'
import { getDateIntervalColumnFieldKey } from '@components/TimeLineGrid/helpers/getDateIntervalColumnFieldKey'
import { isGroupTitleRow } from '@components/TimeLineGrid/helpers/isGroupTitleRow'
import { DateInterval } from '@components/TimeLineGrid/helpers/splitIntervalByPeriod'
import { useHandlers } from '@components/TimeLineGrid/hooks'

import {
  TIME_LINE_DATE_INTERVAL_CELL_CLASS_NAME,
  TIME_LINE_WEEKEND_HEADER_CLASS_NAME,
} from '@constants'
import { COLUMN_TYPE, TimelineCellContext, TimeLineDTOType } from '@types'

type Params = {
  config: TimeLineDTOType
  dateIntervals: DateInterval[]
  handlers: ReturnType<typeof useHandlers>
  cellContextRef: MutableRefObject<TimelineCellContext>
}

export const getColumnsByTimeInterval = (props: Params): GridColDef[] => {
  const { config, dateIntervals, handlers, cellContextRef } = props

  const yColumns = config.objectY.columns || []
  const xColumns = config.objectX?.columns || []

  return dateIntervals.map(({ startDate, endDate }) => {
    const dayOfWeek = moment(startDate).day() // 0 = Sunday, 6 = Saturday
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6

    return {
      columnType: COLUMN_TYPE.DATE_INTERVAL,
      field: getDateIntervalColumnFieldKey(startDate, endDate), // Формируем ключ к данным на основе даты начала и даты окончания
      headerName: config.showDayOfWeek
        ? moment(startDate).locale('ru').format('dd DD')
        : moment(startDate).format('DD'),
      headerAlign: 'center',
      headerClassName: isWeekend ? TIME_LINE_WEEKEND_HEADER_CLASS_NAME : '',
      flex: 1,
      minWidth: config.objectX.cell?.minWidth,
      sortable: false,
      resizable: false,
      disableReorder: true,
      disableColumnMenu: true,
      cellClassName: params =>
        isGroupTitleRow(params.id as string) ? '' : TIME_LINE_DATE_INTERVAL_CELL_CLASS_NAME,
      colSpan: (_, row) => {
        if (isGroupTitleRow(row.id)) {
          return (
            yColumns.filter(item => !item.pinnedColumn).length +
            dateIntervals.length +
            xColumns.filter(item => !item.pinnedColumn).length
          )
        }

        return 1
      },
      renderCell: params => {
        return (
          <ObjectXDynamicCell
            cellContextRef={cellContextRef}
            config={config}
            handlers={handlers}
            params={params}
          />
        )
      },
    }
  })
}
